
/**
 * Unifies environment variable access for different build systems.
 * Supports both Vite (import.meta.env) and standard Node/Edge (process.env) environments.
 */
export const getEnv = (key: string): string => {
  const variants = [
    key,
    `VITE_${key}`,
    `NEXT_PUBLIC_${key}`,
    key.toUpperCase(),
    `VITE_${key.toUpperCase()}`
  ];

  // 1. Try process.env (Standard in this environment)
  try {
    // @ts-ignore
    if (typeof process !== 'undefined' && process.env) {
      for (const v of variants) {
        // @ts-ignore
        if (process.env[v]) return process.env[v];
      }
    }
  } catch (e) {}

  // 2. Try import.meta.env (Vite standard)
  try {
    // @ts-ignore
    if (typeof import.meta !== 'undefined' && import.meta.env) {
      for (const v of variants) {
        // @ts-ignore
        if (import.meta.env[v]) return import.meta.env[v];
      }
    }
  } catch (e) {}

  return '';
};

export const CONFIG = {
  SUPABASE_URL: getEnv('SUPABASE_URL'),
  SUPABASE_ANON_KEY: getEnv('SUPABASE_ANON_KEY'),
  API_KEY: getEnv('API_KEY'),
  get IS_SUPABASE_CONFIGURED() {
    return !!this.SUPABASE_URL && !!this.SUPABASE_ANON_KEY && !this.SUPABASE_URL.includes('placeholder') && this.SUPABASE_URL.startsWith('http');
  },
  get IS_AI_CONFIGURED() {
    return !!this.API_KEY;
  }
};
